import React from 'react';
const bonuses = [{
  title: 'Senior Class Starter Pack™',
  description: 'Un sistema espresso per preparare qualsiasi lezione in pochi minuti: fogli di consultazione rapida, checklist operative, script professionali di apertura e chiusura e modelli di pianificazione rapida.'
}, {
  title: '30 Micro-Routine Express™',
  description: '30 micro-routine pronte da 3, 5 e 7 minuti, classificate per obiettivo, livello e tempo disponibile, per attivare il gruppo in modo sicuro e professionale senza improvvisare.'
}, {
  title: 'Senior Adaptation Cheat Sheets™',
  description: 'Schede rapide per sapere esattamente come modificare gli esercizi in tempo reale secondo livello, mobilità ed equilibrio, con tabelle di progressioni, regressioni e frasi per correggere con eleganza.'
}, {
  title: '12 Lezioni Jolly per Classi Miste™',
  description: '12 lezioni versatili e complete pronte per i giorni con gruppi eterogenei o poco tempo, con regressioni, progressioni e adattamenti integrati per ogni livello.'
}, {
  title: 'Senior Coaching Cues & Commands™',
  description: 'Biblioteca completa di cue verbali, comandi di conduzione, frasi per la correzione tecnica e indicazioni di postura, respirazione e motivazione per comunicare con più autorità e presenza.'
}];
const benefits = [{
  emoji: '⚡',
  title: 'Risparmia Ore Ogni Settimana',
  description: 'Smetti di creare lezioni da zero. Apri il sistema, scegli la sessione e insegna.'
}, {
  emoji: '👑',
  title: 'Maggiore Fiducia Professionale',
  description: 'Sapere esattamente cosa insegnare, come far progredire i partecipanti e come adattare le lezioni in sicurezza.'
}, {
  emoji: '🦵',
  title: 'Migliori Risultati per i Partecipanti',
  description: 'Programmi strutturati su mobilità, equilibrio, forza e indipendenza nei movimenti quotidiani.'
}, {
  emoji: '😊',
  title: 'Maggiore Partecipazione e Fidelizzazione',
  description: 'Mantieni i partecipanti motivati con sessioni coinvolgenti e programmazione progressiva che mostra risultati reali.'
}];
export function BonusSection() {
  return <>
      <section className="py-10 px-4 sm:px-6 bg-petrol text-white" data-id="element-15">
        <div className="text-center mb-8" data-id="element-16">
          <h2 className="text-2xl sm:text-4xl font-heading font-bold mb-2 leading-tight uppercase text-gold" data-id="element-17">
            5 Bonus Premium Inclusi
          </h2>
          <p className="text-base sm:text-xl font-subheading font-bold text-ivory mb-1" data-id="element-18">
            Inoltre, riceverai 5 bonus premium
          </p>
          <p className="text-sm sm:text-base text-ivory/80 max-w-2xl mx-auto" data-id="element-19">
            Risorse esclusive progettate per farti risparmiare ancora più tempo
            e offrire risultati migliori.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-5xl mx-auto mb-8" data-id="element-20">
          {bonuses.map((bonus, i) => <div key={i} className={`bg-petrol-dark border border-gold/40 p-5 rounded-xl text-center shadow-lg ${i === 3 ? 'lg:col-start-1 lg:col-span-1 lg:translate-x-1/2' : ''} ${i === 4 ? 'lg:col-start-2 lg:col-span-1 lg:translate-x-1/2' : ''}`} data-id="element-21">
              <div className="inline-block bg-gold/20 text-gold font-body font-bold text-xs px-3 py-1.5 rounded mb-3 tracking-widest uppercase" data-id="element-22">
                🎁 BONUS {i + 1} — GRATIS
              </div>
              <h3 className="text-base sm:text-lg font-bold text-ivory mb-2 leading-tight font-heading" data-id="element-23">
                {bonus.title}
              </h3>
              <p className="text-sm text-ivory/80 leading-relaxed" data-id="element-24">
                {bonus.description}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-25">
          <p className="inline-block font-body font-bold text-gold text-sm sm:text-base uppercase tracking-widest bg-gold/10 px-6 py-3 rounded-lg border border-gold/30" data-id="element-26">
            I 5 bonus sono GRATIS con il tuo acquisto di oggi.
          </p>
        </div>
      </section>

      <section className="py-10 px-4 sm:px-6 bg-ivory border-b-4 border-cream" data-id="element-27">
        <h2 className="text-2xl sm:text-4xl font-heading font-bold text-center text-petrol mb-2 leading-tight uppercase" data-id="element-28">
          Cosa Cambierà?
        </h2>
        <p className="text-base sm:text-xl font-subheading font-bold text-center text-sage mb-1" data-id="element-29">
          Cosa cambierà nella tua vita professionale
        </p>
        <p className="text-sm sm:text-base text-center text-graphite mb-8 font-bold" data-id="element-30">
          Benefici reali già dalla tua prima settimana:
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-4xl mx-auto" data-id="element-31">
          {benefits.map((item, i) => <div key={i} className="bg-cream border-l-4 border-sage p-5 rounded-r-xl shadow-md flex gap-3 items-start hover:border-petrol transition-colors" data-id="element-32">
              <div className="text-3xl shrink-0 leading-none" data-id="element-33">{item.emoji}</div>
              <div data-id="element-34">
                <h3 className="text-base sm:text-lg font-bold text-petrol mb-1.5 uppercase tracking-wide font-body" data-id="element-35">
                  {item.title}
                </h3>
                <p className="text-graphite text-sm leading-relaxed" data-id="element-36">
                  {item.description}
                </p>
              </div>
            </div>)}
        </div>
      </section>
    </>;
}